import { commonDownloadFile } from './common-download-file';

const COUNT_ALL_PRIZES = 15;

export const getStudentCertFilePath = (studentId: number, subject: string) => {
    const countNumber = studentId % COUNT_ALL_PRIZES;

    return `https://e7n.s3.yandex.net/static/education/student/certificates/${subject}/new/student_cert_${countNumber}.pdf`;
};

export const downloadStudentCert = (studentId: number, subject: string, fileName: string) => {
    const filePath = getStudentCertFilePath(studentId, subject);

    return commonDownloadFile(filePath, fileName);
};
